<template>
  <div>
    <!-- Phoneports -->
    <!-- todo, figure out what to do with voip -->
    <div>
      <div>
        <h4>Additional Voice services</h4>
      </div>
      <div>
        <p>If you would like XMission to contact you about adding phone services, please check the box below.</p>
        <b-form-checkbox v-model="form_data.contact">Contact me about setting up XMission Voice on my connectivity service</b-form-checkbox>
      </div>
    </div>
  </div>
</template>


<script>
  import { BFormCheckbox } from 'bootstrap-vue';
  import VoiceService from '../../../lib/ssu/input_models/voice-service';

  export default ({
  data () {
    return {
      form_data: {contact: false},
    }
  },

  props: {
    value: {
      required: false,
      default: () => {}
    },
    // service should be an instance of VoiceService
    service: {
      required: true,
      type: VoiceService
    }
  },

  computed: {
    serviceSubmissionData () {
      return this.form_data;
    },
    serviceReady() {
      return true;
    },
  },

  watch : {
    serviceSubmissionData: {
      handler (new_val, old_val) {
        this.$emit('input', new_val);
      },
      deep: true
    },
    serviceReady (new_val, old_val) {
      if (new_val){
        this.$emit('form-valid');
      }
      else {
        this.$emit('form-invalid');
      }
    }
  },

  components: {
    BFormCheckbox
  }
})

</script>



// WEBPACK FOOTER //
// VoiceService.vue?49636fad